// extracted by mini-css-extract-plugin
export default {"container":"ResponsiveContainer_container__+s8xL"};